import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import "../../theme/styles/uploadPicture.css";
import Heading from "./Heading";
import { useDispatch } from "react-redux";
import { toast } from "../../store/toastSlice";
import { AlertType } from "../constants/enums";
import { EErrorMessages } from "../constants/api-constant";
const UploadPicture = (props: any) => {
  const [image, setImage] = useState<string | null>(null);
  const [base64Image, setBase64Image] = useState<string | ArrayBuffer | null>(
    ""
  );

  const [isLargeImage, setIsLargeImage] = useState(false);
  const [isformatChange, setIsformatChange] = useState(false);
  const dispatch = useDispatch();

  const handleImageChange = (event: any) => {
    const file = event.target.files[0];
    if (file) {
      if (file.size > 2097152) {
        setIsLargeImage(true);
        return;
      }
      if (!["image/jpg", "image/jpeg", "image/png"].includes(file.type)) {
        setIsformatChange(true);
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(URL.createObjectURL(file));
        const image = reader.result?.toString().split(",")[1] || "";
        setBase64Image(image);
      };
      reader.readAsDataURL(file);
    }
  };

  const openFile = () => {
    const input = document.getElementById("fileInput") as HTMLInputElement;
    if (input) {
      input.click();
      input.value = "";
    }
  };

  useEffect(() => {
    props.getBase64Image(base64Image);
  }, [base64Image]);

  useEffect(() => {
    props.image && setImage(props.image);
  }, [props.image]);

  useEffect(() => {
    if (isLargeImage) message(EErrorMessages.FileSizeExceededMessage);
    else if (isformatChange) message(EErrorMessages.ErrorInvalidFileFormat);
    return () => {
      setIsLargeImage(false);
      setIsformatChange(false);
    };
  }, [isLargeImage, isformatChange]);

  const message = (message: string) => {
    dispatch(
      toast({
        isOpen: true,
        message: message,
        type: AlertType.ERROR,
      })
    );
  };

  return (
    <Box
      data-testid="upload-area"
      className={`uploadPic ${image ? "" : "defaultProfile"}`}
      onClick={(e) => openFile()}
    >
      <div className="content">
        {image ? (
          <Box className="preview">
            <img src={image} alt="Uploaded" className="previewImg" />
            <span className="material-symbols-outlined photo_camera">
              photo_camera
            </span>
          </Box>
        ) : (
          <>
            <span className="material-symbols-outlined photo_camera">
              photo_camera
            </span>
            <Heading type="body2" classes="text" text=" Upload Picture" />
          </>
        )}
        <input
          type="file"
          id="fileInput"
          data-testid="file-input"
          style={{ display: "none" }}
          accept=".png, .jpg, .jpeg"
          onChange={handleImageChange}
          required
        />
      </div>
    </Box>
  );
};
export default UploadPicture;
